"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  sendForm: {
    position: 'relative',
    boxSizing: 'border-box',
    '&.hidden': {
      display: 'none'
    },
    '&.disabled': {
      opacity: theme.disabledOpacity,
      cursor: 'default'
    },
    '& .user': {
      color: theme.primaryColor,
      padding: '0 2px',
      borderRadius: 4,
      display: 'inline-block',
      fontWeight: 600,
      height: 20
    }
  },
  input: {
    'word-break': 'break-word',
    paddingTop: 8,
    paddingBottom: 0,
    minHeight: 60
  },
  chat: {
    paddingTop: 4,
    borderTop: `1px solid ${theme.sendForm.borderColor}`,
    '& .field': {
      borderBottom: 0,
      cursor: 'text'
    },
    '&.error': {
      borderTop: `1px solid ${theme.errorColor}`
    }
  },
  quote: {
    backgroundColor: 'rgba(25, 115, 232, 0.05)',
    borderRadius: theme.sendForm.quote.borderRadius,
    boxSizing: 'border-box',
    padding: 8,
    marginTop: 16,
    display: 'flex',
    width: '100%',
    '& .hidden': {
      display: '-webkit-box',
      '-webkit-line-clamp': 3,
      '-webkit-box-orient': 'vertical',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    }
  },
  quoteText: {
    fontStyle: 'italic',
    paddingTop: 2,
    lineHeight: '22px'
  },
  quoteShowBtn: {
    padding: 0,
    width: 'max-content',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent !important'
    }
  },
  quoteWrap: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    justifyContent: 'left'
  },
  comment: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.sendForm.borderColor,
    borderRadius: theme.sendForm.borderRadius,
    padding: '0 16px 16px 16px',
    '& .field': {
      borderBottom: 0,
      cursor: 'text'
    },
    '&.focus': {
      border: `1px solid ${theme.sendForm.active.borderColor}`
    },
    '&.error': {
      border: `1px solid ${theme.errorColor}`
    }
  },
  artifacts: {
    display: 'flex'
  },
  rating: {
    cursor: 'pointer',
    '& span': {
      padding: '2px 5px',
      boxSizing: 'border-box'
    },
    '& span:last-child': {
      marginRight: '0 !important'
    }
  },
  divider: {
    width: 1,
    backgroundColor: theme.sendForm.borderColor,
    marginRight: 7,
    marginLeft: -8
  },
  done: {
    borderColor: theme.sendForm.done.borderColor,
    backgroundColor: theme.sendForm.done.backgroundColor,
    '& i:first-child': {
      '& .fill': {
        fill: theme.sendForm.done.iconFill
      }
    }
  },
  sign: {
    borderColor: theme.sendForm.sign.borderColor,
    backgroundColor: theme.sendForm.sign.backgroundColor,
    '& i:first-child': {
      '& .fill': {
        fill: theme.sendForm.sign.iconFill
      }
    }
  },
  reject: {
    borderColor: theme.sendForm.reject.borderColor,
    backgroundColor: theme.sendForm.reject.backgroundColor,
    '& i:first-child': {
      transform: 'rotate(45deg)',
      '& .fill': {
        fill: theme.sendForm.reject.iconFill
      }
    }
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    position: 'relative'
  },
  controlsBtn: {
    '& div': {
      marginLeft: 8
    }
  },
  controlsIcons: {
    display: 'flex',
    '& .fill': {
      fill: theme.sendForm.iconFill
    }
  },
  controlsIconsItem: {
    marginRight: 16,
    cursor: 'pointer',
    position: 'relative',
    '&.reject': {
      transform: 'rotate(45deg)'
    },
    '&.quotationMark': {
      padding: 4,
      marginRight: 8,
      '&:hover': {
        fill: theme.sendForm.quote.iconFill
      }
    },
    '&.quotationCancel': {
      padding: 6,
      marginRight: 0,
      marginLeft: 8
    }
  },
  usersList: {
    transformOrigin: 'left bottom 0',
    position: 'absolute',
    bottom: 98,
    width: '100%',
    maxWidth: '100%',
    maxHeight: 200,
    '&.hidden': {
      transformOrigin: 'left bottom 0'
    }
  }
});

exports.default = _default;